export const login_url = '/student/login';
export const video_list = "/student/practise/data/video";
export const dashboard_list = "/student/dashboard";
export const reference_book_list = "/student/reference/Detail";
export const dashboard_listNew = "/student/dashboardnew";
export const sign_up = "/student/signup";
export const send_otp = "/student/send/otp";
export const verify_otp = "/student/verify/otp";
export const profile_update = "/student/profile/update";